import React from "react";

const ImageOverlay = ({ handleClick }) => (
  <div onClick={() => handleClick()} className="c-wall__overlay" />
);

export default ImageOverlay;
